import * as React from 'react';

import { classNames } from 'uitk-react-utils';

import { BaseMoreFilters } from '.';

import { FlightsSearchFormMoreFiltersOption } from 'types/search/wizard';

interface MoreFiltersMenuProps {
  searchOption: FlightsSearchFormMoreFiltersOption;
}

export const MoreFiltersMenu = ({ searchOption }: MoreFiltersMenuProps) => {
  const { label } = searchOption;
  const formId = 'search-form-more-filters';
  const formClasses = classNames('all-y-margin-one', 'all-x-margin-three');

  return (
    <form id={formId} className={formClasses}>
      <fieldset>
        <legend className="is-visually-hidden">{label}</legend>
        <BaseMoreFilters searchOption={searchOption} />
      </fieldset>
    </form>
  );
};
